import React from 'react';

import { SkeletonLoader } from '@sm/webassets';
import { ProgressCircle } from '@sm/wds-react';

import './ucs-module-loaders.scss';

const TopBarSkeleton = () => (
  <div className="sm-ucs-module-loaders__top-bar--skeleton" data-testid="UCSModuleLoaders__TopBarSkeleton">
    <SkeletonLoader />
  </div>
);

const DefaultLoader = () => (
  <div className="wds-flex wds-flex--x-center" data-testid="UCSModuleLoaders__DefaultLoader">
    <ProgressCircle continuous />
  </div>
);

const MODULE_SKELETONS = {
  top_bar: TopBarSkeleton,
};

export default DefaultLoader;
export { MODULE_SKELETONS };
